import axios from '../utils/axios.wrapper';

export const getAllAllergens = async () => {
  const response = await axios.get('/Allergen');
  return response.data.items || response.data.Items || [];
};

export const createAllergenApi = async (payload) => {
  const response = await axios.post('/Allergen/create', payload);
  return response.data;
};

export const updateAllergenApi = async (id, payload) => {
  await axios.put(`/Allergen/${id}`, payload);
  return { id, payload };
};

export const deleteAllergenApi = async (id) => {
  await axios.delete(`/Allergen/${id}`);
  return id;
};

export const allergenService = {
  getAllAllergens,
  createAllergen: createAllergenApi,
  updateAllergen: updateAllergenApi,
  deleteAllergen: deleteAllergenApi,
};